import React, { useEffect } from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  useFormHandler,
} from "../../../../../../components";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { addNewImmigrationsStart, updateImmigrationsStart } from "../../../../../../redux/slices/immigration/immigrationSlice";
import { useDispatch, useSelector } from "react-redux";
import { PayFrequency } from "../../../../../../assets/data/enumData";

const JobDetails = ({handleBackOrCancel,editData = null}) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const { immigrations: immigrationTableData, currentImmgration } = useSelector(
    (state) => state.immigration
  );
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      billableClient: "",
      jobTitle: "",
      jobStartDate: "",
      jobEndDate: "",
      comments: "",
      effectiveDate: "",
      effectiveUntil: "",
      payRate: "",
      payType: "",
    },
    // {
    //   billableClient: {
    //     type: "text",
    //     required: true,
    //   },
    //   jobTitle: {
    //     type: "title",
    //     required: true,
    //   },
    // }
  );

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const updateJobDeatils = {
        jobDetails: {
          billClient: formData.billableClient?.value ?? formData.billableClient,
          entityType: formData.billableClient?.coll,
          jobTitle: formData.jobTitle?.value ?? formData?.jobTitle,
          startDate: formData.jobStartDate,
          endDate: formData.jobEndDate,
          comment: formData.comments,
        },
        payRevision: {
          effectiveFrom: formData.effectiveDate,
          effectiveTill: formData.effectiveUntil,
          payRate: formData.payRate,
          payType: formData.payType,
        },
      };
      const submissionData = filterEmptyValues(updateJobDeatils);
        const isEditing = !!(currentImmgration?.uiid || editData?.uiid||currentImmgration?.data?.uiid);
const uiid = isEditing ? (currentImmgration?.uiid || editData?.uiid||currentImmgration?.data?.uiid) : "";
      dispatch(
        addNewImmigrationsStart({
         uiid: uiid,
          coll: "LCA",
           rsd:submissionData,
            rsn:"lcaInfoJob",
          payload: [
            {
              type: "SET",
              value: {
                  ...submissionData,
              },
            },
          ],
          onSuccess: async (payload) => {
          handleBackOrCancel()
          },
        })
      );
    } else {
      console.log("Errors  : ", errors);
    }
  };
    useEffect(() => {
      const lcaInfoJob = currentImmgration?.lcaInfoJob;
      if (lcaInfoJob) {
       handleChange("billableClient", lcaInfoJob?.jobDetails?.billClient)
       handleChange("jobTitle", lcaInfoJob?.jobDetails?.jobTitle)
       handleChange("jobStartDate", lcaInfoJob?.jobDetails?.startDate)
       handleChange("jobEndDate", lcaInfoJob?.jobDetails?.endDate)
       handleChange("comments", lcaInfoJob?.jobDetails?.comment)
       handleChange("effectiveDate", lcaInfoJob?.payRevision?.effectiveFrom)
       handleChange("effectiveUntil", lcaInfoJob?.payRevision?.effectiveTill)
       handleChange("payRate", lcaInfoJob?.payRevision?.payRate)
       handleChange("payType", lcaInfoJob?.payRevision?.payType)
      }
   },[])
    useEffect(() => {
      const lcaInfoJob = editData;
       const lcaInfoData=currentImmgration?.lcaInfoJob;
      console.log("lcaInfoJob",lcaInfoJob);
      console.log("isEditable",isEditable);
      if (lcaInfoJob&&isEditable&&!lcaInfoData) {
       handleChange("billableClient", lcaInfoJob?.jobDetails?.billClient?.businessName?{label:lcaInfoJob?.jobDetails?.billClient?.businessName,value:lcaInfoJob?.jobDetails?.billClient?.uiid,coll:lcaInfoJob?.jobDetails?.entityType}:"")
       handleChange("jobTitle", lcaInfoJob?.jobDetails?.jobTitle)
       handleChange("jobStartDate", lcaInfoJob?.jobDetails?.startDate)
       handleChange("jobEndDate", lcaInfoJob?.jobDetails?.endDate)
       handleChange("comments", lcaInfoJob?.jobDetails?.comment)
       handleChange("effectiveDate", lcaInfoJob?.payRevision?.effectiveFrom)
       handleChange("effectiveUntil", lcaInfoJob?.payRevision?.effectiveTill)
       handleChange("payRate", lcaInfoJob?.payRevision?.payRate)
       handleChange("payType", lcaInfoJob?.payRevision?.payType)
      }
   },[])
  return (
    <div className="px-8 py-6 border-[1px] border-neutrals-50">
      <div>
        <p>JOB DETAILS</p>
        <Divider />
        <div className="grid grid-cols-2 xl:grid-cols-3 max-w-7xl mt-6 gap-x-6 gap-y-8">
          <FormFieldSet
            type="allClientsList"
            title={"Billable Client"}
            placeholder="Enter Client"
            value={formData.billableClient}
            onChange={(value) => handleChange("billableClient", value)}
            error={errors.billableClient}
            showSearch
          />
          <FormFieldSet
            type="jobTitle"
            title={"Job Title"}
            placeholder="Enter JobTitle"
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            showSearch
            showButton
          />
          <FormFieldSet
            type="datepicker"
            title={"Job Start Date"}
            placeholder="Select Start Date"
            value={formData.jobStartDate}
            onChange={(value) => handleChange("jobStartDate", value)}
            error={errors.jobStartDate}
            maxDate={formData?.jobEndDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Job End Date"}
            placeholder="Select End Date"
            value={formData.jobEndDate}
            onChange={(value) => handleChange("jobEndDate", value)}
            error={errors.jobEndDate}
            minDate={formData?.jobStartDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="textArea"
            title={"Comments"}
            placeholder="Enter Comments"
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
          />
        </div>
        <div className="mt-6">
          <p> PAYMENT REVISIONS</p>
          <Divider />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 max-w-7xl mt-6 gap-x-6 gap-y-8 ">
          <FormFieldSet
            type="datepicker"
            title={"Effective Date"}
            placeholder="select Effective Date"
            value={formData.effectiveDate}
            onChange={(value) => handleChange("effectiveDate", value)}
            error={errors.effectiveDate}
            maxDate={formData?.effectiveUntil}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Effective Until"}
            placeholder="Select Effective"
            value={formData.effectiveUntil}
            onChange={(value) => handleChange("effectiveUntil", value)}
            error={errors.effectiveUntil}
            minDate={formData?.effectiveDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="text"
            title={"Pay Rate"}
            placeholder="Enter Pay Rate"
            value={formData.payRate}
            onChange={(value) => handleChange("payRate", value)}
            error={errors.payRate}
          />
          <FormFieldSet
            type="select"
            title={"Pay Type"}
            placeholder="select Type"
            value={formData.payType}
            onChange={(value) => handleChange("payType", value)}
            error={errors.payType}
            // options={[
            //   { label: "A", value: 1 },
            //   { label: "B", value: 2 },
            //   { label: "C", value: 3 },
            // ]}
            options={PayFrequency}
          />
        </div>
        <div className="mt-6 mb-3">
          <p> ROLES & RESPONSIBILITIES </p>
          <Divider />

          <div className="border-[1px] border-neutrals-100 min-h-[250px] mt-4 p-6 rounded-md">
            <h6>text Editor</h6>
          </div>
        </div>
        <div className="flex gap-3 justify-end my-6">
          <Button title="Cancel" variant="outlined"  />
          <Button title="Save" onClick={() => handleSave()} />
        </div>
      </div>
    </div>
  );
};

export default JobDetails;
